<div class="prom-avatar {sizeClass}">
    {#if length}
        {#if (typeof src !== 'string') && length > 1}
            <div class="prom-avatar__images {numberClass}">
                {#each avatars as avatar, i}
                    {#if avatar}
                        <img class="prom-avatar__image" src={avatar} alt={alternativeText[i] || ""} />
                    {:else}
                        <div class="prom-avatar__image"></div>
                    {/if}
                {/each}
            </div>
        {:else}
            {#if avatars[0]}
                <img class="prom-avatar__image" src={avatars[0]} alt={altAvatarDescriptions[0] || ""} />
            {:else}
                <div class="prom-avatar__image"></div>
            {/if}
        {/if}
    {:else}
        <div class="prom-avatar__image"></div>
    {/if}
</div>

<script>
    $: sizeClass = `prom-avatar--${size}`;

    /** @type {number} */
    export let size = 200;
    /** @type {string|string[]} */
    export let src = [];
    /** @type {string|string[]} */
    export let alternativeText = [];

    $: length = src ? src.length : undefined;

    $: avatars = (typeof src === 'string')
        ? [src]
        : getFirstThree(src);

    $: altAvatarDescriptions = (typeof alternativeText === 'string')
        ? [alternativeText]
        : getFirstThree(alternativeText);
    $: numberClass = (typeof src === 'string') ? '' : getNumberClass(length);

    function getNumberClass(length) {
        switch(length) {
            case 1: return 'prom-avatar--1';
            case 2: return 'prom-avatar--2';
            default: return 'prom-avatar--3';
        }
    }

    function getFirstThree(src) {
        return Array.isArray(src)
            ? src.slice(0, 3)
            : src;
    }
</script>
